
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import useAccount from "@/composables/useAccount";
import useAccountPages from "@/composables/useAccountPages";
import { Component } from "@/models/enums";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { defineComponent, reactive, ref } from "vue";

export default defineComponent({
	components: { BaseInput, BaseButton, BaseSvg, BaseAlert },
	setup() {
		const userStore = useUserStore();
		const { setComponent } = useAccountPages();
		const { forgotPassword } = useAccount();

		const loading = ref(false);
		const success = ref(false);

		const goToLogin = () => {
			setComponent(Component[Component.AccountLogin]);
		};

		const state = reactive({
			email: userStore.getUser.email,
		});

		const rules = {
			email: { required },
		};

		const v$ = useVuelidate(rules, state);

		const submitForm = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();

			if (isValid) {
				loading.value = true;
				forgotPassword(state.email ?? "")
					.then(() => (success.value = true))
					.finally(() => (loading.value = false));
			}
		};

		return { goToLogin, submitForm, v$, loading, success };
	},
});
